

const ENMarketShare = {
	"adicionado com sucesso": "successfully added",
	"alterado com sucesso": "successfully changed",
	"Alterar Análise": "Change Analysis",
	"Alterar": "Change",
	"Análise adicionada com sucesso": "Analysis successfully added",
	"Análise alterada com sucesso": "Analysis successfully changed",
	"Análise": "Analysis",
	"Comentário adicionado com sucesso": "Comment successfully added",
	"Concorrente": "Competitor",
	"Concorrentes não podem ser repetidos": "Competitors cannot be repeated",
	"Crescimento": "Growth",
	"Deseja realmente excluir o": "Do you really want to delete the",
	"Digite o título da análise para excluí-la": "Type the title of the analysis to delete it",
	"Editar": "Edit",
	"Erro ao adicionar análise": "Error adding analysis",
	"Erro ao adicionar comentário": "Error adding comment",
	"Erro ao adicionar": "Error adding",
	"Erro ao alterar análise": "Error changing analysis",
	"Erro ao alterar": "Error changing",
	"Erro ao buscar comentário": "Error searching comment",
	"Erro ao carregar": "Error loading",
	"excluído com sucesso": "sucessfully deleted",
	"Exclusão de análise": "Deletion of analysis",
	"Exclusão de": "Deletion of",
	"Gráfico de Análise": "Analysis Chart",
	"Gráfico de": "Chart of",
	"Inserir Análise": "Insert Analysis",
	"Insira algum valor para poder visualizar no grafico": "Insert a value to be able to see the chart",
	"movido com sucesso": "successfully moved",
	"Nenhum concorrente adicionado": "No competitor added",
	"Nenhum {{agrupador}} encontrado": "No {{agrupador}} found",
	"Nova Análise": "New Analysis", 
	"Novo": "New",
	"Visualizar Gráfico": "View Chart"
};


export default ENMarketShare;
